import React from "react";

export const InfoField = (props) => {
	const {items, label} = props;

	return (
		<>
			{!!items && !!items.length && (
				<div className="infoField">
					<span className="infoName">{label}</span>
					<div className="infoDataList">
						{items.map((item, index) => (
							<span className="infoData" key={index}>
                {" "}
								{item.name || item.value}
								{index + 1 < items.length ? ", " : null}{" "}
              </span>
						))}
					</div>
				</div>
			)}
		</>
	);
};